import { FETCH_CATEGORIES_MAP, FETCH_CATEGORIES_ATTEMPT_MAP } from './types'
import axios from 'axios';
export const fetchcategoriesmap = () => {

    return (dispatch) => {
        dispatch({ type: FETCH_CATEGORIES_ATTEMPT_MAP });
        //call the backend
            axios.post('https://zliten.onwan.ly/API/addresses/fetchCats.php')
             .then((resp) => dispatch({ type: FETCH_CATEGORIES_MAP, data: resp.data }))
            /* .then((resp) => console.log(resp.data))*/
            .catch(error => console.error(error));
    }
}
